module.exports = __webpack_public_path__ + "static/media/sas.cca852e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/sas.svg
// module id = 109
// module chunks = 3